import React from "react";

import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatting } from "@north-beam/nb-common";

import { type FormattedBreakdownTableRow } from "./table";

export const SpendCellFormatter = ({
  value,
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  // const row = _row as FormattedBreakdownTableRow;

  return (
    <div className=" h-full px-1 font-mono w-full truncate ">
      <span>{value}</span>
    </div>
  );
};
